import React, { memo } from "react";
import { Outlet } from "react-router-dom";
import { Tooltip } from "react-tooltip";

import SupportIcon from "../../assets/img/support-icon.png";

const TOOLTIP_ID = "onboarding-support-tip";
const TOOLTIP_TEXT =
  "Click here to contact ALATPay Support for onboarding assistance.";

const WHATSAPP_NUMBER = (process.env.REACT_APP_SUPPORT_WHATSAPP_NUMBER || "")
  .replace(/\D/g, "")
  .replace(/^0/, "234");

const LINK_PROPS = WHATSAPP_NUMBER
  ? {
    href: `https://wa.me/${WHATSAPP_NUMBER}`,
    target: "_blank",
    rel: "noopener noreferrer"
  }
  : { role: "link", tabIndex: 0, "aria-disabled": true };

if (!WHATSAPP_NUMBER && process.env.NODE_ENV !== "test") {
  console.warn(
    "OnboardingSupportWidget: REACT_APP_SUPPORT_WHATSAPP_NUMBER is not set, so the support icon has no WhatsApp link."
  );
}

const TOOLTIP_STYLE = {
  maxWidth: 260,
  zIndex: 60,
  backgroundColor: "#A90836",
  color: "#FFFFFF",
  borderRadius: 10,
  padding: "10px 14px",
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.45,
  boxShadow: "0 8px 24px rgba(169, 8, 54, 0.25)"
};

const OnboardingSupportWidget = memo(() => (
  <>
    <a
      {...LINK_PROPS}
      aria-label={TOOLTIP_TEXT}
      data-tooltip-id={TOOLTIP_ID}
      data-tooltip-content={TOOLTIP_TEXT}
      className="fixed bottom-20 right-2.5 z-50 rounded-full shadow-lg transition-transform duration-200 hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-alat-light focus:ring-offset-2"
    >
      <img
        src={SupportIcon}
        alt=""
        width={56}
        height={56}
        className="w-14 h-14 rounded-full"
      />
    </a>
    <Tooltip
      id={TOOLTIP_ID}
      place="left"
      offset={12}
      opacity={1}
      delayShow={150}
      style={TOOLTIP_STYLE}
    />
  </>
));

OnboardingSupportWidget.displayName = "OnboardingSupportWidget";
export const OnboardingSupportLayout = () => (
  <>
    <Outlet />
    <OnboardingSupportWidget />
  </>
);

export default OnboardingSupportWidget;
